// TODO: Incorporate this back into Interaction component
import React, { useState, useEffect } from 'react';
import AmiraIconButton, { ICON_BUTTON_TYPES } from '../Global/AmiraIconButton2/AmiraIconButton2';
import cx from 'classnames';
import IconOverlays from './IconOverlays';
import BookOverlay from '../Global/BookOverlay/BookOverlay';
import ReactiveListeningStatus from '../Global/ReactiveListeningStatus/ReactiveListeningStatus';
import Timer from './Timer';

export const POINTER_IDS = {
  PROMPT: "PROMPT",
  TIMER: "TIMER",
  YOUR_TURN: "YOUR_TURN",
  REPEAT_BUTTON: "REPEAT_BUTTON",
  HINT_BUTTON: "HINT_BUTTON",
  EXCERPTS_BUTTON: "EXCERPTS_BUTTON",
  MICROPHONE: "MICROPHONE",
  TEXT_BOX: "TEXT_BOX",
  SUBMIT_BUTTOM: "SUBMIT_BUTTOM",
}

const DialogDisplay = ({ 
  // Enabled States
  submitButtonEnabled, 
  excerptsButtonEnabled,
  hintButtonEnabled,
  helpButtonsEnabled,
  repeatButtonEnabled, 
  // Visibility States
  showRepeatButton, 
  showHintButton,
  showExcerptsButton,
  showSubmitButton,
  showMicrophone,
  showPauseOverlay,
  showLoadingOverlay,
  showCheckmarkOverlay,
  showTimer,
  showStudentTurn,
  showExcerptsOverlay, 
  showPrompt,
  // Interaction Handlers
  onClickRepeat, 
  onClickSubmit, 
  onClickHint, 
  onClickExcerpts, 
  onCloseExcerpts, 
  onTextResponseChange,
  // Content
  leftPageContent,
  rightPageContent,
  currentHint,
  // Misc
  activePointer,
  useTextInput,
  fakeActiveListeningStatus,
  textResponseInputRef,
  textResponse,
  transcript,
  submitTimerElapsed,
  getNoSubmitTimeout,
  promptText,
  assessment,
}) => {
  // Volume Faker
  const [volumeLevel, setVolumeLevel] = useState(0);

  const [volumeTimeout, setVolumeTimeout] = useState(null);
  useEffect(() => {
    clearTimeout(volumeTimeout);
    setVolumeLevel(5);

    setVolumeTimeout(setTimeout(() => {
      setVolumeLevel(0);
    }, 1000))

  }, [transcript]);

  const getPromptBlock = () => {
    return (
      <div className={cx('prompt', { invisible: !showPrompt })}>
        <div className='repeatButtonWrapper'>
          <AmiraIconButton
            onClick={onClickRepeat}
            disabled={!repeatButtonEnabled}
            type={ICON_BUTTON_TYPES.REPEAT_AUDIO}
            invisible={!showRepeatButton}
            pointerPosition='right'
            showPointer={activePointer === POINTER_IDS.REPEAT_BUTTON}
            assessment={assessment}
            secondary
          />
        </div>
        {promptText}
      </div>
    );
  };

  const getIconOverlays = () => {
    return (
      <>
        <IconOverlays
          showPauseOverlay={showPauseOverlay}
          showLoadingOverlay={showLoadingOverlay}
          showCheckmarkOverlay={showCheckmarkOverlay}
        />
      </>
    );
  };

  const getExcerptsOverlay = () => {
    return (
      <BookOverlay
        leftPageContent={leftPageContent}
        rightPageContent={rightPageContent}
        onClose={onCloseExcerpts}
      />
    );
  };

  const getButtonsColumn = () => {
    return (
      <div className='buttonsCol'>
        <div className={`buttonsWrapper ${showExcerptsButton || showHintButton ? '' : 'hidden'}`}>
          <div style={{ marginBottom: '10px' }}>
            <AmiraIconButton
              onClick={onClickExcerpts ? onClickExcerpts : () => {}}
              disabled={!submitButtonEnabled || !excerptsButtonEnabled || !helpButtonsEnabled}
              type={ICON_BUTTON_TYPES.BOOK}
              invisible={!showExcerptsButton}
              pointerPosition='right'
              showPointer={activePointer === POINTER_IDS.EXCERPTS_BUTTON}
              assessment={assessment}
            />
          </div>

          <AmiraIconButton
            onClick={onClickHint ? onClickHint : () => {}}
            disabled={!currentHint || !submitButtonEnabled || !hintButtonEnabled || !helpButtonsEnabled}
            type={ICON_BUTTON_TYPES.QUESTION_MARK}
            invisible={!showHintButton}
            pointerPosition='right'
            showPointer={activePointer === POINTER_IDS.HINT_BUTTON}
            assessment={assessment}
          />
        </div>
      </div>
    );
  };

  const getInputColumn = () => (
    <div className='inputCol'>
      {useTextInput && (
        <div className={cx('textInputWrapper', {
          invisible: !showMicrophone,
          pointerTarget: true,
          left: true,
          showPointer: activePointer === POINTER_IDS.TEXT_BOX
        })}
        >
          <textarea
            ref={textResponseInputRef}
            type='text'
            spellCheck="false"
            disabled={!submitButtonEnabled}
            onChange={onTextResponseChange}
            value={textResponse}
            autoCapitalize="none"
            autoCorrect="off"
            aria-label="dialog item text response"
          />

        </div>
      )}
      {!useTextInput && (
        <div 
          className={cx('listeningStatusWrapper', {
            invisible: !showMicrophone,
            pointerTarget: true,
            left: true,
            showPointer: activePointer === POINTER_IDS.MICROPHONE,
          })}
        >
          <ReactiveListeningStatus
            forceActiveState={fakeActiveListeningStatus}
            volumeLevel={volumeLevel ? volumeLevel : 0}
            large
          />
        </div>
      )}
      {getIconOverlays()}
    </div>
  );

  const getSubmitColumn = () => (
    <div className='submitCol'>
      <div className={`submitButtonWrapper ${showSubmitButton ? '' : 'hidden'}`}>
        <AmiraIconButton
          onClick={onClickSubmit}
          disabled={!submitButtonEnabled}
          type={ICON_BUTTON_TYPES.SUBMIT}
          invisible={!showSubmitButton}
          pointerPosition='left'
          showPointer={activePointer === POINTER_IDS.SUBMIT_BUTTOM}
          large
          assessment={assessment}
        />
      </div>
    </div>
  );

  const getTimer = () => (
    <div 
      className={cx('timerRow', {
        invisible: !showTimer,
        pointerTarget: true,
        left: true,
        showPointer: activePointer === POINTER_IDS.TIMER,
      })}
    >
      <Timer
        submitTimerElapsed={submitTimerElapsed}
        getNoSubmitTimeout={getNoSubmitTimeout}
      />
    </div>
  );

  return (
    <div className="Interaction">
      {getPromptBlock()}
      <div 
        className={cx('controlContainer', { 
          show: showStudentTurn,
          invisible: !showStudentTurn,
        })}
      >
        {showExcerptsOverlay && getExcerptsOverlay()}
        {getTimer()}
        <div className='submitRow'>
          {getButtonsColumn()}
          {getInputColumn()}
          {getSubmitColumn()}
        </div>
      </div>
    </div>
  );
};

export default DialogDisplay;